/**
 * `/code-review/auto-approve` — *Auto-approve PRs* section.
 */
import { SettingsForm } from '../../components/SettingsForm.js';

export default function CodeReviewAutoApprove() {
  return (
    <main className="feluda-settings">
      <SettingsForm
        section="autoApprove"
        title="Auto-approve PRs"
        subtitle="Automatically merge PRs Feluda reviews as low-risk."
      />
    </main>
  );
}
